import { Component, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EnvironmentService } from './_services/environment.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'user-management';

  protected envService: EnvironmentService = inject(EnvironmentService);

  ngOnInit() {
    this.envService.config.next(  environment );
  }
}
